import { BalikovnaExtendedPoint } from 'helpers/balikovna/types';
import { PickupPointType } from 'types/pickupPoint';

export function mapBalikovnaExtendedPoint(point: BalikovnaExtendedPoint): PickupPointType {
    return {
        identifier: point.zip,
        name: point.name,
        email: null,
        telephone: null,
        description: '',
        openingHours: null,
        street: point.address ? mapAddressToStreet(point.address) : '',
        postcode: point.zip,
        city: point.municipality_name,
        country: { code: 'CZ', name: 'Česká republika' },
        disabled: false,
        reservationDisabled: false,
        locationLatitude: null,
        locationLongitude: null,
    };
}

const mapAddressToStreet = (address: string): string => {
    const parts = address.split(',');

    return parts[0];
};
